import { action, makeObservable, observable } from 'mobx';

class WheelStore {
  wheelResultsHistory = [];

  wheelRoundResult = null;

  constructor() {
    makeObservable(this, {
      wheelRoundResult: observable,
      wheelResultsHistory: observable.deep,
      setWheelResult: action.bound,
      setWheelTimerToggle: action.bound,
      setWheelResultsHistory: action.bound,
    });
  }

  setWheelResult(data) {
    this.wheelRoundResult = data;
  }

  setWheelResultsHistory(wheelResults) {
    this.wheelResultsHistory = wheelResults;
  }

  setWheelTimerToggle(boolean) {
    if (boolean) {
      // eslint-disable-next-line no-unused-expressions
      document.body.clientWidth;
    }
  }
}

export const wheelStore = new WheelStore();
